import React from "react";
import { useTranslation } from "react-i18next";
import StatusBadge from "./StatusBadge";

/** Page header: title + appointment number + status badge, plus an optional banner. */
const AppointmentViewHeader = ({ item, banner }) => {
  const { t } = useTranslation();

  return (
    <header className="appt-header">
      <div className="appt-header__top">
        <h1 className="appt-header__title">
          {t("appointmentView.title")}
          {item?.appid && <span className="appt-header__id">#{item.appid}</span>}
        </h1>
        <StatusBadge status={item?.status} billable={!!item?.appointment_details?.is_billable_cancel} />
      </div>

      {banner}
    </header>
  );
};

export default AppointmentViewHeader;
